module.exports = __webpack_public_path__ + "img/cartao-nacional-saude.d8637af7.png";